module.exports = __webpack_public_path__ + "img/4.5a238284.svg";